export default {
  // UI
  isLoading : state => state.isLoading,

  // matrix
  matrix : state => state.matrix,

  // mouse actions
  lastClickedCubeIndex : state => state.lastClickedCubeIndex,
  selectedCubeType : state => state.selectedCubeType
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js